import { useMutation, useQueryClient } from "react-query";

import useApiHelper from "../../services/useApiHelper";

import { windowDisplaysQueryKeys } from "./queryKeys";
import { WindowDisplayCreate, WindowDisplayUpdate } from "../../models/windowDisplay/WindowDisplay";

export function useWindowDisplayMutations(agencyId: string) {
  const queryClient = useQueryClient();
  const { post, put, del } = useApiHelper();

  const create = useMutation(
    (data: WindowDisplayCreate) => post(`/windowdisplay/${agencyId}`, data),
    {
      onSuccess: (_) => {
        queryClient.invalidateQueries(windowDisplaysQueryKeys.all(agencyId));
      },
    }
  );

  const update = useMutation(
    (data: WindowDisplayUpdate) =>
      put(`/windowdisplay/${data.id}`, data),
    {
      onSuccess: (_) => {
        queryClient.invalidateQueries(windowDisplaysQueryKeys.all(agencyId));
      },
    }
  );

  const remove = useMutation(
    (id: string) => del(`/windowdisplay/${id}`),
    {
      onSuccess: (_) => {
        queryClient.invalidateQueries(windowDisplaysQueryKeys.all(agencyId));
      },
    }
  );

  return {
    create,
    update,
    remove,
  };
}

